<rp-balance-cards (getPayouts)="handleGetPayouts()" />

<rp-table-wrapper [shouldShowSpinner]="isLoading()">
  <div class="full-width" tableFilter>
    <div [class]="isDesktop() ? 'row' : 'column'" class="space__between table-filters__title">
      {{ 'finance.historyOfPayouts' | translate }}
      <rp-filters-webmaster (filterChanged)="handleFilterChanged($event)" />
    </div>
  </div>

  @if (isDesktop()) {
    <rp-table
      #table
      tableBody
      [columns]="columns"
      [itemsLength]="payouts().itemsCount"
      (sort)="handleSortChanged($event)"
      (pagination)="handlePaginationChanged($event)"
      titlePlaceholder="finance.tableTitlePlaceholder"
      subtitlePlaceholder="finance.tableSubtitlePlaceholder"
    >
      @for (item of payouts().payouts; track item.id) {
        <div rpRow [item]="item">
          <rp-cell cellDef="id">{{ item.id }}</rp-cell>
          <rp-cell cellDef="date">
            <div class="font-medium__12">{{ item.date | date: DateFormat.ShortDate }}</div>
            <div>{{ item.date | date: DateFormat.TimeWithSeconds }}</div>
          </rp-cell>
          <rp-cell cellDef="method">
            <div class="font-bold__12">{{ paymentMethods()?.get(item.paymentMethodId) }}</div>
          </rp-cell>
          <rp-cell cellDef="network">
            <div class="font-bold__12">{{ paymentNetworks()?.get(item.networkId) }}</div>
          </rp-cell>
          <rp-cell cellDef="walletAddress">
            <div class="row space__between">
              <div class="font-bold__12" [attr.title]="item.walletAddress">{{ item.walletAddress }}</div>
              <rp-icon class="cursor__pointer" [iconName]="icons.Copy" size="s" (click)="clipboardService.copy(item.walletAddress)" />
            </div>
          </rp-cell>
          <rp-cell cellDef="status">
            <rp-finance-status [status]="item.status" />
          </rp-cell>
          <rp-cell cellDef="amount">
            <div class="font-medium__14" [attr.title]="item.amountCents | centsToDollarsPipe">
              {{ item.amountCents | centsToDollarsPipe }}
            </div>
          </rp-cell>
          <rp-cell cellDef="action">
            <rp-icon class="font-medium__14 cursor__pointer" iconName="eye" (click)="openDetails(item)" />
          </rp-cell>
        </div>
      }
      <rp-button underPlaceholder type="secondary" routerLink="/profile" [queryParams]="{ tab: 'paymentMethod' }">
        {{ 'profile.addPaymentMethod' | translate }}
      </rp-button>
    </rp-table>
  } @else {
    <rp-table-mobile
      #table
      tableBody
      titlePlaceholder="finance.tableTitlePlaceholder"
      subtitlePlaceholder="finance.tableSubtitlePlaceholder"
      [data]="payouts().payouts"
      [itemsLength]="payouts().itemsCount"
      [template]="templateRef"
      (pagination)="handlePaginationChanged($event)"
    >
      <rp-button underPlaceholder type="secondary" routerLink="/profile" [queryParams]="{ tab: 'paymentMethod' }">
        {{ 'profile.addPaymentMethod' | translate }}
      </rp-button>
    </rp-table-mobile>
  }
</rp-table-wrapper>

<ng-template #templateRef let-data="data">
  <rp-finance-mobile-view
    #table
    [data]="data"
    (click)="openDetails(data)"
    [paymentMethods]="paymentMethods()"
    [payoutStatuses]="payoutStatuses()"
  />
</ng-template>
